import React, {Component} from 'react';
import classNames from 'classnames';
import styles from './form.module.scss';
import PhosphorIcon from '../icons/PhosphorIcon';
//import PropTypes from 'prop-types';

const encode = data => {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');
};

export default class Form extends Component {
  state = {
    name: '',
    email: '',
    field: '',
    success: false,
  };

  handleSubmit = e => {
    e.preventDefault();

    const submission = {
      name: this.state.name,
      email: this.state.email,
      field: this.state.message,
    };

    fetch('https://formbucket.com/f/buk_sdzUuOoRYgVMGDC8IhqLXPa3', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: encode({'form-name': 'contact', ...submission}),
    }).then(() => this.setState({success: true}));
  };

  update = e => this.setState({[e.target.name]: e.target.value});

  renderFields() {
    const {name, email, message, success} = this.state;

    if (success) {
      return null;
    }

    return (
      <div>
        <div className="field">
          <label className={classNames('label', styles.Form__label)}>
            Your Name
          </label>
          <div className="control">
            <input
              className="input"
              name="name"
              onChange={this.update}
              required={true}
              type="text"
              value={name}
            />
          </div>
        </div>
        <div className="field">
          <label className={classNames('label', styles.Form__label)}>
            Email
          </label>
          <div className="control">
            <input
              className="input"
              name="email"
              onChange={this.update}
              required={true}
              type="email"
              value={email}
            />
          </div>
        </div>
        <div className="field">
          <label className={classNames('label', styles.Form__label)}>
            Message
          </label>
          <div className="control">
            <textarea
              className="textarea"
              name="message"
              onChange={this.update}
              required={true}
              rows={2}
              value={message}
            />
          </div>
        </div>
        <button className={styles.Form__button} type="submit">
          Send Your Message
        </button>
      </div>
    );
  }

  renderText() {
    const {success} = this.state;
    const className = styles.Form__heading__text;

    if (!success) {
      return (
        <p className={className}>
          We would love to hear from you!
          <br />
          Send us your questions or feedback.
        </p>
      );
    }

    return (
      <p className={className}>
        Thanks! We got your message.
        <br />
        We'll be in touch soon.
      </p>
    );
  }

  render() {
    const {success} = this.state;

    return (
      <form
        className={classNames(styles.Form, {
          [styles['Form--success']]: success,
        })}
        data-netlify="true"
        onSubmit={this.handleSubmit}
      >
        <div className={styles.Form__heading}>
          <span className={styles.Form__icon}>
            <PhosphorIcon
              name={success ? 'envelopeSimpleOpen' : 'chatCircleText'}
              size={24}
            />
          </span>
          {this.renderText()}
        </div>
        {this.renderFields()}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/Form.js